export enum CurrencyCode {
  USD = 'USD',
  MXN = 'MXN',
  EUR = 'EUR',
  BRL = 'BRL',
  COP = 'COP',
}
